import React, {useState, useEffect} from "react";

import { Link } from "react-router-dom";
import moment from "moment";
import "./../../Public/css/bootstrap.min.css";
import "./../../Public/css/tabler-icons.css";
import "./../../Public/css/fontawesome.min.css";
import "./../../Public/css/all.min.css";
import "./../../Public/css/style.css";

import {DashboardAPI} from "./../../API/Publisher/DashboardAPI";
import Sidebar from "./Common/Sidebar";
import Header from "./Common/Header";
import Loader from "./../Loader";


const Dashboard = () =>{

	const [todayleadcount, setTodayLeadCount] = useState(0);
	const [totalleadcount, setTotalLeadCount] = useState(0);
	const [weekleadcount, setWeekLeadCount] = useState(0);
	const [monthleadcount, setMonthLeadCount] = useState(0);
	const [duplicateleadcount, setDuplicateLeadCount] = useState(0);
	const [loggedname, setLoggedName] = useState("");
	const [loading, setLoading] = useState(true);
	const current = moment();

	useEffect(() =>{

		const userinfo = localStorage.getItem("userinfo");

		if(userinfo !== "" && userinfo !== null && userinfo !== undefined)
        {
            const loggeduserdata = JSON.parse(userinfo);

            setLoggedName(loggeduserdata.name);
        }
		
	}, []);

	useEffect(() =>{
		console.log('Publisher dahboard');

		DashboardAPI(setTodayLeadCount, setTotalLeadCount, setWeekLeadCount, setMonthLeadCount, setDuplicateLeadCount, setLoading);
		
	}, []);

	const handleReloadStats = () =>{
		DashboardAPI(setTodayLeadCount, setTotalLeadCount, setWeekLeadCount, setMonthLeadCount, setDuplicateLeadCount, setLoading);
	}
	


    return(
	<div className="main-wrapper">

		<Loader />

		<Header />

		<Sidebar />

		<div className="page-wrapper">
			<div className="content">
				<div className="row">
					<div className="col-md-12">
						<div className="page-header">
							<div className="row align-items-center ">
								<div className="col-md-4">
									<h3 className="page-title">Leads Dashboard</h3>
								</div>
								<div className="col-md-8 float-end ms-auto">
									<div className="d-flex title-head">
										<div className="daterange-picker d-flex align-items-center justify-content-center">
											
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="welcome-wrap mb-4">
					<div class=" d-flex align-items-center justify-content-between flex-wrap">
						<div class="mb-3">
							<h2 class="mb-1 text-white">Welcome {loggedname}</h2>
							<p class="text-light">As of {current.format('DD MMMM YYYY')} {current.format('hh:mm A')}</p>
						</div>
						<div class="d-flex align-items-center flex-wrap mb-1">
							{/*<a href="company.html" class="btn btn-dark btn-md me-2 mb-2">Companies</a>*/}
							<button type="button" class="btn btn-light btn-md mb-2" onClick={handleReloadStats}>Refresh</button>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-md-12">
						<div className="row">
							<div className="col-md-3">
								<div className="card">
									<div className="card-body p-3 d-flex align-items-center mx-auto">                            	
										<div>
											<div className="fs-25 fw-semibold widget-text text-center">{todayleadcount}</div>
											<div className="text-body-secondary fw-semibold widget-heading">Today's Leads</div>
										</div>
									</div>
									<div className="card-footer widget-card-footer px-3 py-2">
										<Link className="btn-block text-body-secondary d-flex justify-content-between align-items-center" to="/publisher/lead/todaylead">
											<span className="small fw-semibold">View all</span>

											<svg xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  strokeWidth="2"  strokeLinecap="round"  strokeLinejoin="round"  className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-right">
												<path stroke="none" d="M0 0h24v24H0z" fill="none"/>
												<path d="M5 12l14 0" />
												<path d="M13 18l6 -6" />
												<path d="M13 6l6 6" />
											</svg>
										</Link>
									</div>
								</div>
							</div>

							<div className="col-md-3">
								<div className="card">
									<div className="card-body p-3 d-flex align-items-center mx-auto">                            	
										<div>
											<div className="fs-25 fw-semibold widget-text text-center">{totalleadcount}</div>
											<div className="text-body-secondary fw-semibold widget-heading">Total Leads</div>
										</div>
									</div>
									<div className="card-footer widget-card-footer px-3 py-2">
										<Link className="btn-block text-body-secondary d-flex justify-content-between align-items-center" to="/publisher/lead/totallead">
											<span className="small fw-semibold">View all</span>

											<svg xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  strokeWidth="2"  strokeLinecap="round"  strokeLinejoin="round"  className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-right">
												<path stroke="none" d="M0 0h24v24H0z" fill="none"/>
												<path d="M5 12l14 0" />
												<path d="M13 18l6 -6" />
												<path d="M13 6l6 6" />
											</svg>
										</Link>
									</div>
								</div>
							</div>

							<div className="col-md-3">
								<div className="card">
									<div className="card-body p-3 d-flex align-items-center mx-auto">                            	
										<div>
											<div className="fs-25 fw-semibold widget-text text-center">{weekleadcount}</div>
											<div className="text-body-secondary fw-semibold widget-heading">Current Week Leads</div>
										</div>
									</div>
									<div className="card-footer widget-card-footer px-3 py-2">
										<Link className="btn-block text-body-secondary d-flex justify-content-between align-items-center" to="/publisher/lead/weeklead">
											<span className="small fw-semibold">View all</span>

											<svg xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  strokeWidth="2"  strokeLinecap="round"  strokeLinejoin="round"  className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-right">
												<path stroke="none" d="M0 0h24v24H0z" fill="none"/>
												<path d="M5 12l14 0" />
												<path d="M13 18l6 -6" />
												<path d="M13 6l6 6" />
											</svg>
										</Link>
									</div>
								</div>
							</div>

							<div className="col-md-3">
								<div className="card">
									<div className="card-body p-3 d-flex align-items-center mx-auto">                            	
										<div>
											<div className="fs-25 fw-semibold widget-text text-center">{monthleadcount}</div>
											<div className="text-body-secondary fw-semibold widget-heading">Current Month Leads</div>
										</div>
									</div>
									<div className="card-footer widget-card-footer px-3 py-2">
										<Link className="btn-block text-body-secondary d-flex justify-content-between align-items-center" to="/publisher/lead/monthlead">
											<span className="small fw-semibold">View all</span>

											<svg xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  strokeWidth="2"  strokeLinecap="round"  strokeLinejoin="round"  className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-right">
												<path stroke="none" d="M0 0h24v24H0z" fill="none"/>
												<path d="M5 12l14 0" />
												<path d="M13 18l6 -6" />
												<path d="M13 6l6 6" />
											</svg>
										</Link>
									</div>
								</div>
							</div>

							<div className="col-md-3">
								<div className="card">
									<div className="card-body p-3 d-flex align-items-center mx-auto">                            	
										<div>
											<div className="fs-25 fw-semibold widget-text text-center">{duplicateleadcount}</div>
											<div className="text-body-secondary fw-semibold widget-heading">Duplicate Leads</div>
										</div>
									</div>
									<div className="card-footer widget-card-footer px-3 py-2">
										<Link className="btn-block text-body-secondary d-flex justify-content-between align-items-center" to="/publisher/lead/duplicatelead">
											<span className="small fw-semibold">View all</span>

											<svg xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  strokeWidth="2"  strokeLinecap="round"  strokeLinejoin="round"  className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-right">
												<path stroke="none" d="M0 0h24v24H0z" fill="none"/>
												<path d="M5 12l14 0" />
												<path d="M13 18l6 -6" />
												<path d="M13 6l6 6" />
											</svg>
										</Link>
									</div>
								</div>
							</div>

						</div>
					</div>					
				</div>

				<div className="row">

				</div>
			</div>
		</div>
	</div>
    )
}

export default Dashboard;